export default __webpack_public_path__ + "static/alfred_search_nm_result-8e28e27192770ae31f2806486c67063f.png";